import gql from 'graphql-tag';

export const FEATURES = gql`
	query Features($featureNames: [String!]!, $path: String!) {
		features(featureNames: $featureNames, path: $path)
	}
`;
